import React from 'react';
import { Backdrop, Box, Slide } from '@mui/material';
import type { NavigationItem } from '../navigationItems';
import { SidebarHeader } from './SidebarHeader';
import { SidebarContent } from './SidebarContent';
import { SIDEBAR_WIDTH } from './constants';
import { DARK_SHELL_SURFACE, LIGHT_SHELL_SURFACE } from '@billda/shared-ui';

interface MobileSidebarProps {
  open: boolean;
  onClose: () => void;
  permissions: string[];
  isActive: (path: string) => boolean;
  collapsedGroups: string[];
  onToggleCollapsed: (group: string) => void;
  onNavigate: (item: NavigationItem) => void;
  onSearch: () => void;
}

export const MobileSidebar: React.FC<MobileSidebarProps> = ({
  open,
  onClose,
  permissions,
  isActive,
  collapsedGroups,
  onToggleCollapsed,
  onNavigate,
  onSearch,
}) => (
  <>
    <Backdrop
      open={open}
      onClick={onClose}
      sx={{
        zIndex: theme => theme.zIndex.drawer + 1,
        bgcolor: 'rgba(0, 0, 0, 0.5)',
      }}
    />
    <Slide direction="right" in={open} mountOnEnter unmountOnExit>
      <Box
        sx={{
          width: SIDEBAR_WIDTH,
          height: '100vh',
          position: 'fixed',
          left: 0,
          top: 0,
          zIndex: theme => theme.zIndex.drawer + 2,
          bgcolor: theme =>
            theme.palette.mode === 'dark'
              ? DARK_SHELL_SURFACE
              : LIGHT_SHELL_SURFACE,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >
        <SidebarHeader onAction={onClose} showClose />
        <SidebarContent
          permissions={permissions}
          isActive={isActive}
          collapsedGroups={collapsedGroups}
          onToggleCollapsed={onToggleCollapsed}
          onNavigate={onNavigate}
          onSearch={onSearch}
        />
      </Box>
    </Slide>
  </>
);
